gsap.set('.co-collection-hero-wrapper.z-ani-o', { opacity: 0 });
gsap.to('.co-collection-hero-wrapper.z-ani-o', {
  opacity: 1,
  duration: 0.5,
  ease: "none"
});
gsap.set('.co-collection-grid-cell.z-ani-o', { opacity: 0, y: 10 });
gsap.to('.co-collection-grid-cell.z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 0.75,
  ease: "Power2.in",
  stagger: 0.075
});

const cC1Swiper1 = new Swiper('.co-collection-hero.swiper', {
  observer: true,
  observeParents: true,
  slidesPerView: 1,
  speed: 500,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  loop: false,
  allowTouchMove: false,
});